import { Component, Input } from '@angular/core';

/**
 * * Componente do indicador de notificações do Apolo.
 */
@Component({
  selector: 'ui-notifications-badge',
  templateUrl: './notifications-badge.component.html',
  styleUrls: ['./notifications-badge.component.scss']
})
export class NotificationsBadgeComponent {

  /**
   * * Cor do Item do Número. (verde ou amarela)
   */
  @Input() badgeColor: 'green' | 'yellow' = 'yellow'; // "green" or "yellow"
  /**
   * * Posição do componente. (absolute ou initial)
   */
  @Input() position: 'absolute' | 'initial' = 'initial'; // "absolute" or "initial"
  /**
   * * Quantidade de Notificações.
   */
  @Input() notificationQuantity: string | number = '0';

  constructor() { }

}
